module.exports = __webpack_public_path__ + "img/mardelplata_spring.b0f89ecd.svg";